<template>
    <div class="BaseSpinner">
        <div>
            <img src="/images/logo.png" alt="Načítání...">
            <p>Načítání...</p>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .BaseSpinner {
        position: fixed;
        z-index: 10;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgb(28 29 25 / 94%);
        display: flex;
        justify-content: center;
        align-items: center;
        perspective: 200px;
        text-align: center;
        font-weight: 700;

        img {
            animation: logoSpin 1.2s linear infinite;
        }

        p {
            color: white;
            animation: colorChange 1s alternate infinite;
        }
    }
</style>
